import queryString, { ParsedQuery } from 'query-string';

type UseQueryParams = {
  getQueryParams: (locationSearch: string) => ParsedQuery;
};

const useQueryParams = (): UseQueryParams => {
  const getQueryParams = (locationSearch: string): ParsedQuery => {
    const search =
      locationSearch.slice(-1) === '/'
        ? locationSearch.slice(0, -1)
        : locationSearch;
    return queryString.parse(search);
  };

  return {
    getQueryParams,
  };
};

export default useQueryParams;
